module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"search":"Suchen"},"en":{"search":"Search"}}')
  delete Component.options._Ctor
}
